/**
 * src/lib/agent/brainChips.js — TICKET-1499 (chat -> brain), pure helpers.
 *
 * CHAT_CHIP_DECISIONS: Confirm / Discard in the chat = brain-clarify accept / reject
 * (vessel_brain_entries.status CHECK). Discard = 'rejected', which every quote read excludes.
 *
 * Chat chips persist with the assistant turn in chat_messages.tool_calls (one entry per
 * chip, name 'brain_chip') and are split back out on hydrate, so a reload still shows them.
 */
export const CHAT_CHIP_DECISIONS = Object.freeze({ confirm: 'accepted', discard: 'rejected' });

const BRAIN_CHIP_CALL = 'brain_chip';

/** tool chips + brain chips -> chat_messages.tool_calls (unchanged when there are no brain chips). */
export function packChatToolCalls(toolChips, brainChips) {
  if (!brainChips?.length) return toolChips || null;
  return [
    ...(toolChips || []),
    ...brainChips.map((c) => ({ name: BRAIN_CHIP_CALL, chip_id: c.id, text: c.text, kind: c.kind })),
  ];
}

/** chat_messages.tool_calls -> { toolChips, brainChips } for the message list. */
export function splitChatToolCalls(toolCalls) {
  const list = Array.isArray(toolCalls) ? toolCalls : [];
  return {
    toolChips: list.filter((c) => c?.name !== BRAIN_CHIP_CALL),
    brainChips: list.filter((c) => c?.name === BRAIN_CHIP_CALL).map((c) => ({ id: c.chip_id, text: c.text, kind: c.kind })),
  };
}
